import React, { FC } from "react";
import { Backdrop, Button, CircularProgress, Modal } from "@mui/material";
import styles from "./ConfirmModal.module.scss";

interface ConfirmModalProps {
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  warnings: string[] | TrustedHTML[];
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
  warnings,
}) => {
  return (
    <div className="create-promotion-modal">
      {/* Full-screen Backdrop */}
      <Modal
        open={true}
        onClose={onClose}
        aria-labelledby="confirm-modal-title"
        aria-describedby="confirm-modal-description"
      >
        {/* Modal Container */}
        <div className={styles["modal-container"]}>
          {/* Modal Title */}
          <h4 className={styles["modal-container__title"]}>Confirm</h4>

          {/* Confirmation Message */}
          <div className={styles["modal-container__input-wrapper"]}>
            Please confirm to issue credits
          </div>
          {warnings && warnings.length > 1 ? (
            <ul className={styles["modal-container__list-container"]}>
              {warnings?.map((warning, i) => (
                <li
                  key={i}
                  className={styles["modal-container__list-container__list"]}
                  dangerouslySetInnerHTML={{ __html: warning }}
                ></li>
              ))}
            </ul>
          ) : (
            <p
              className={styles["modal-container__single-desc"]}
              dangerouslySetInnerHTML={{ __html: warnings?.[0] }}
            />
          )}

          {/* Action Buttons Container */}
          <div className={styles["modal-container__button-group"]}>
            {/* Cancel Button - Closes modal without blocking */}
            <Button
              onClick={onClose}
              type="button"
              className={`${styles["modal-container__button-group__cancel-button"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isSubmitting} // Disabled during confirm to prevent cancellation
            >
              Cancel
            </Button>

            {/* Confirm Button - Initiates confirm process */}
            <Button
              onClick={onSubmit}
              type="button"
              className={`${styles["modal-container__button-group__submit-button"]} create-promo-submit-button`}
              variant="contained"
              disabled={isSubmitting} // Disabled during confirm to prevent duplicate requests
            >
              {/* Show loading spinner during confirm, otherwise show "Confirm" text */}
              {isSubmitting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Confirm"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
